import { AccountSettings } from '../../components/settingsTabs/AccountSettings'
import { InformationSettings } from '../../components/settingsTabs/InformationSettings'
import { BusinessSettings } from '../../components/settingsTabs/BusinessSettings'
// import styles from './UserSettingsPage.module.css'
import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { NotificationSettings } from '../../components/settingsTabs/NotificationSettings'
import { CalendarIntegrations } from '../../components/settingsTabs/CalendarIntegrations'
import { Grid, Typography, useMediaQuery } from '@mui/material'
import styles from './UserSettingsPage.module.scss'
import AccountPaymentTierPage from '../../components/settingsTabs/AccountPaymentTierPage'

import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import { setSettingsTab } from '../../features/authSlice'
import { STAFF_ROLES } from '../../util/constants'

const TAB_ICONS = [
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14 4.66634V11.333C14 13.333 13 14.6663 10.6667 14.6663H5.33333C3 14.6663 2 13.333 2 11.333V4.66634C2 2.66634 3 1.33301 5.33333 1.33301H10.6667C13 1.33301 14 2.66634 14 4.66634Z"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.6665 3V4.33333C9.6665 5.06667 10.2665 5.66667 10.9998 5.66667H12.3332"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.3335 8.66699H8.00016"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.3335 11.333H10.6668"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>,
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.99984 7.99967C9.84079 7.99967 11.3332 6.50729 11.3332 4.66634C11.3332 2.82539 9.84079 1.33301 7.99984 1.33301C6.15889 1.33301 4.6665 2.82539 4.6665 4.66634C4.6665 6.50729 6.15889 7.99967 7.99984 7.99967Z"
			stroke="#313131"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M13.7268 14.6667C13.7268 12.0867 11.1601 10 8.0001 10C4.8401 10 2.27344 12.0867 2.27344 14.6667"
			stroke="#313131"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>,
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M8.01242 1.94043C5.80575 1.94043 4.01242 3.73376 4.01242 5.94043V7.8671C4.01242 8.27376 3.83908 8.89376 3.63242 9.24043L2.86575 10.5138C2.39242 11.3004 2.71908 12.1738 3.58575 12.4671C6.45908 13.4271 9.55908 13.4271 12.4324 12.4671C13.2391 12.2004 13.5924 11.2471 13.1524 10.5138L12.3857 9.24043C12.1857 8.89376 12.0124 8.27376 12.0124 7.8671V5.94043C12.0124 3.74043 10.2124 1.94043 8.01242 1.94043Z"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
		/>
		<path
			d="M9.24792 2.13297C9.04125 2.07297 8.82792 2.0263 8.60792 1.99964C7.96792 1.91964 7.35458 1.9663 6.78125 2.13297C6.97458 1.63964 7.45458 1.29297 8.01458 1.29297C8.57458 1.29297 9.05458 1.63964 9.24792 2.13297Z"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.0132 12.707C10.0132 13.807 9.11318 14.707 8.01318 14.707C7.46652 14.707 6.95985 14.4804 6.59985 14.1204C6.23985 13.7604 6.01318 13.2537 6.01318 12.707"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
		/>
	</svg>,
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.3335 14.667H14.6668"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.3333 1.33301H4.66667C2.66667 1.33301 2 2.52634 2 3.99967V14.6663H14V3.99967C14 2.52634 13.3333 1.33301 11.3333 1.33301Z"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.6665 11H6.6665"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.3335 11H11.3335"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.6665 8H6.6665"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.3335 8H11.3335"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M4.6665 5H6.6665"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.3335 5H11.3335"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>,
	<AttachMoneyIcon />,
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M5.33301 1.83398V3.83398"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.667 1.83398V3.83398"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M2.33301 6.56055H13.6663"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14 6.16732V11.834C14 13.834 13 15.1673 10.6667 15.1673H5.33333C3 15.1673 2 13.834 2 11.834V6.16732C2 4.16732 3 2.83398 5.33333 2.83398H10.6667C13 2.83398 14 4.16732 14 6.16732Z"
			stroke="#313131"
			stroke-width="1.5"
			stroke-miterlimit="10"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.4625 9.63411H10.4685"
			stroke="#313131"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10.4625 11.6341H10.4685"
			stroke="#313131"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.99666 9.63411H8.00265"
			stroke="#313131"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M7.99666 11.6341H8.00265"
			stroke="#313131"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.52987 9.63411H5.53585"
			stroke="#313131"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M5.52987 11.6341H5.53585"
			stroke="#313131"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>,
]

const tabs = [
	[TAB_ICONS[0], 'Information Settings'],
	[TAB_ICONS[1], 'Account Settings'],
	[TAB_ICONS[2], 'Notification Preferences'],
	[TAB_ICONS[5], 'Calendar Integrations'],
	[TAB_ICONS[4], 'Subscriptions'],
	[TAB_ICONS[3], 'Business Information'],
]

export const UserSettingsPage = () => {
	const dispatch = useDispatch()
	const [searchParams, setSearchParams] = useSearchParams()
	const value = useSelector((s) => s.auth.settingsTab)
	const accountType = useSelector((state) => state.auth.accountType)

	useEffect(() => {
		const calendar = searchParams.get('calendar')
		const tab = searchParams.get('tab')
		if (calendar === 'connected' || calendar === 'error') {
			dispatch(setSettingsTab(3))
			setSearchParams({}, { replace: true })
		} else if (tab != null && tab !== '') {
			const tabIndex = parseInt(tab, 10)
			if (!Number.isNaN(tabIndex) && tabIndex >= 0 && tabIndex <= 5) {
				dispatch(setSettingsTab(tabIndex))
				setSearchParams({}, { replace: true })
			}
		}
	}, [searchParams, dispatch, setSearchParams])

	const handleChange = (e, newValue) => {
		dispatch(setSettingsTab(newValue))
	}

	const renderTab = () => {
		switch (value) {
			case 0:
				return <InformationSettings />
			case 1:
				return <AccountSettings />
			case 2:
				return <NotificationSettings />
			case 3:
				return <CalendarIntegrations />
			case 4:
				return <AccountPaymentTierPage />
			case 5:
				return <BusinessSettings />
		}
	}
	const isSmallScreen = useMediaQuery('(max-width:1199px)')
	return (
		<>
			<section className={styles.profileSection}>
				<div className={styles.inner}>
					<div className={styles.title}>
						<Typography variant="h1">Profile</Typography>
					</div>
					<Grid container alignItems={'unset'} spacing={{ xs: 2 }}>
						<Grid size={{ xs: 12, lg: 2.5 }}>
							<Tabs
								value={value}
								onChange={handleChange}
								orientation={
									isSmallScreen ? 'horizontal' : 'vertical'
								}
								variant={
									isSmallScreen ? 'scrollable' : 'standard'
								}
								scrollButtons={isSmallScreen ? 'auto' : false}
								allowScrollButtonsMobile={isSmallScreen}
								aria-label="scrollable force tabs example"
								sx={{
									'& .MuiTabs-scrollButtons.Mui-disabled': {
										opacity: '0.3',
									},

									'& .MuiTabs-indicator': {
										left: '0',
										right: 'auto',
										backgroundColor: '#7CA6BD',
									},
									'& .MuiButtonBase-root': {
										fontFamily: 'Inter',
										fontSize: '14px',
										fontWeight: '500',
										color: '#313131',
										textAlign: 'left',
										'&.Mui-selected': {
											color: '#7CA6BD',
											'& svg path': {
												stroke: '#7CA6BD',
											},
										},
									},
									'@media (max-width: 1199px)': {
										minHeight: 'unset',
										height: 'unset',
										maxHeight: 'unset',
										'& .MuiButtonBase-root': {
											padding: '6px 10px',
										},
										// '& .MuiTabs-list': {
										// 	overflowX: 'auto',
										// 	flexWrap: 'nowrap',
										// },
									},
								}}
							>
								{tabs.map((data) => {
									if (
										data[1] === 'Business Information' &&
										accountType !== 'vendor' &&
										accountType !== 'kazoo-planner'
									) {
										return
									} else if (
										data[1] === 'Subscriptions' &&
										STAFF_ROLES.includes(accountType)
									)
										return

									return (
										<Tab
											key={data[1]}
											sx={{
												textTransform: 'none',
												minHeight: '0',
												justifyContent: 'start',
											}}
											icon={data[0]}
											iconPosition="start"
											disableRipple
											label={data[1]}
										/>
									)
								})}
							</Tabs>
						</Grid>
						<Grid size={{ xs: 12, lg: 9.5 }}>{renderTab()}</Grid>
					</Grid>
				</div>
			</section>
		</>
	)
}
